import { Box, Paper, Stack, Typography } from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { VChainerFooter } from '../../../app/components/VChainerFooter';
import { Locale, selectSettings } from '../../settings/settingsSlice';
import { useAppSelector } from '../../../app/hooks';
import { LanguageToggle } from '../../../app/components/LanguageToggle';
import { useState } from 'react';

type Language = 'pl' | 'en';

interface Props {
    language: Language;
}

const texts = {
    title: {
        pl: 'Wiadomość z linkiem do dokumentu została wysłana.',
        en: 'A message with a link to the document has been sent.',
        de: 'Eine Nachricht mit einem Link zum Dokument wurde gesendet.',
    },
    description: {
        pl: 'Sprawdź swoją skrzynkę odbiorczą na podanym adresie e‑mail. W razie potrzeby zajrzyj również do folderu spam.',
        en: 'Check your inbox at the provided email address. If needed, also check your spam folder.',
        de: 'Prüfen Sie den Posteingang der angegebenen E-Mail-Adresse und gegebenenfalls Ihren Spam-Ordner.',
    },
    header: {
        pl: 'Dziękujemy za skorzystanie z systemu V-Chainer',
        en: 'Thank you for using the V-Chainer system',
        de: 'Vielen Dank, dass Sie V-Chainer nutzen',
    },
};

export const DocumentAccessLinkSentPanel = () => {
    const { locale } = useAppSelector(selectSettings);
    const [language, setLanguage] = useState<Locale>(locale);
    const lang = language === 'en-US' ? 'en' : language;

    return (
        <Paper
            elevation={4}
            sx={{
                p: 5, maxWidth: 700, position: 'relative',
                width: { xs: '94vw', sm: 500, md: 600 }, borderRadius: 3, textAlign: 'center'
            }}
        >
            <Stack
                sx={{
                    maxWidth: 500,
                    mx: 'auto',
                    my: 4,
                    p: 4,
                    alignItems: 'center',
                    textAlign: 'center',
                }}
                spacing={2}
            >
                <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
                    <LanguageToggle onChange={setLanguage} />
                </Box>
                <MarkEmailReadIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
                <Typography variant="h5">
                    {texts.title[lang]}
                </Typography>

                <Typography variant="subtitle1" color="text.secondary">
                    {texts.description[lang]}
                </Typography>
            </Stack>

            <VChainerFooter />
        </Paper>
    );
};
